/**
 * Vue 全局过滤器
 * 
 * @author qingguipeng
 * @email qingguipeng@Foxmail.com
 * @date 2019年10月20日 18:41:51
 */

import numeral from 'numeral';


export default {
    numFormat: (value, format) => {
        format = format || "0,0.00";
        return numeral(value / 100).format('0,0.00');
    },
}